import {label} from "@/class/label";

export class boundingzoom extends label{
    
    objectType = "boundingzoom";
    parentObjectType = "interactive_image";
    
    data = [
        ...this._default.coords,
        {name: "width", type:Number, default: 0.0},
        {name: "height", type:Number, default: 0.0},
        {name: "panType", type:String, default: "pan_horizontal"},
    ]
    
    constructor() {
        super();
        this.init();
    }
}